"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
export default function AboutPremiumHero() {
  // 保留原有滾動偵測，讓內容進場時優雅地由下往上滑入
  const {
    ref: headerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section ref={headerRef} data-section-id="172542" id="page-header" className="relative h-[55vh] min-h-[450px] md:min-h-[550px] w-full overflow-hidden bg-[#f3ede5] flex items-center">
    
      <div className="absolute inset-0 z-0">
        <img src="https://hent.services/wp-content/uploads/2026/05/About-Hents_TOP-scaled.webp" alt="Hent's Flooring Heritage" className="h-full w-full object-cover object-[50%_35%] scale-100" />
   
        <div className="absolute inset-0 bg-white/5 md:bg-transparent" />
      </div>

      {/* 內容排版層 - 100% 復刻圖片左下角優雅幾何排版 */}
      <div className="container relative z-30 mx-auto px-6 md:px-12 lg:px-24">
        {/* 動態進學：改為更具人文氣息的溫柔由下往上（translate-y）浮現 */}
        <div className={cn("max-w-3xl transition-all duration-[1200ms] ease-out", isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0")}>
          
          {/*  核心修改 4：麵包屑導覽 
              - 字級縮小，字距拉開到 tracking-[0.25em] 展現高端雜誌感
              - 顏色換成品牌高級副色 #7a6a59，路徑改為 ABOUT HENT'S
           */}
          <nav className="mb-14 md:mb-20 flex items-center gap-1.5 text-lg md:text-xl font-sans tracking-[0.25em] text-[#7a6a59] font-medium">
            <Link to="/" className="hover:text-[#604f45] transition-colors">HOME</Link>
            <span>/</span>
            <span className="text-[#604f45] uppercase">About Hent's</span>
          </nav>

          {/*  核心修改 5：主副標題區塊
              - 移除原本粗重的「品牌故事」大字與黃色橫線。
              - 主標題改為大寫現代極簡美式粗體：LIVE GENTLY。
              - 顏色使用高階偏深灰褐 #3d3d3d（非純黑），耐看且質感深邃。
           */}
          <div className="space-y-4 md:space-y-5 select-none">
            <h1 className="font-sans text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-[#3d3d3d] tracking-[0.1em] uppercase leading-none">
              Live Gently
            </h1>
            
            {/*  核心修改 6：人文金句短語
                - 使用 font-hk-regular 帶出舒適的中文閱讀呼吸感
                - 字級縮小至 text-sm md:text-base，字距大幅拉開（tracking-widest），極致內斂
             */}
            <p className="font-hk-regular  text-1xl md:text-2xl text-[#3d3d3d]/90 tracking-widest leading-relaxed pl-0.5">
              喜歡的生活 ｜ 其實可以很簡單
            </p>
          </div>

        </div>
      </div>
    </section>;
}